import type { CommentSource, CommentsSort } from './models';

export const COMMENTS_QK = 'comments';

function sourceKey(source: CommentSource) {
  return source.kind === 'event'
    ? { kind: 'event', eventId: source.eventId }
    : { kind: 'news', slug: source.slug };
}

export function commentsQueryKey(
  source: CommentSource,
  sort?: CommentsSort,
  onlyHolders?: boolean,
  onlyMine?: boolean,
) {
  const key: unknown[] = [COMMENTS_QK, sourceKey(source)];
  if (sort !== undefined) key.push(sort);
  if (onlyHolders !== undefined) key.push(onlyHolders);
  if (onlyMine !== undefined) key.push(onlyMine);
  return key;
}

export function commentsQueryKeyPrefix(source: CommentSource) {
  return [COMMENTS_QK, sourceKey(source)];
}
